<template>
  <div class="mt-4 about-page">
    <div class="row">
      <div class="col-4 col-lg-3">
        <about-nav />
      </div>
      <div class="col-7 text-left">
        <h2 class="mb-4">FAQ</h2>

        <h5 class="text-muted mb-4">License &amp; Usage</h5>

        <p class="mb-4">
          <strong>Can I use these gradients on my site?</strong><br>
          Yes, gradients and derived images can be used on commercial and personal sites.  Attribution is required.
        </p>

        <p class="mb-4">
          <strong>Is attribution required?</strong><br>
          Yes, unless you have one of the <router-link to="/premium">premium licenses</router-link>.
        </p>

        <p class="mb-4">
          <strong>Can I show a gallery of gradients on my website?</strong><br>
          Maybe.  The <router-link to="/extended">extended license</router-link> lets you give gradient customization options to your users, but you can never re-distribute gradients or derived images.
        </p>

        <h5 class="text-muted mb-4">General Questions</h5>

        <p class="mb-4">
          <strong>Do You Create These By Hand?</strong><br>
          No, I have a set of tools that help me create them. Eventually some of those tools might be made public, but for now I am still improving them.
        </p>


        <p class="mb-4">
          <strong>Where are all the <a href="https://developer.mozilla.org/en-US/docs/Web/CSS/conic-gradient()" target="_blank">Conic Gradients</a>?</strong><br>
          I’m waiting for browser support to get a little better.
        </p>

        <p class="mb-4"> 
          <strong>I Have an Idea for a Gradient</strong><br>
          I’d love to hear it! Eventually I hope to add a “user submitted” section.
        </p>
      
      </div>
    </div>
  </div>
</template>

<script>
import AboutNav from "@/components/AboutNav.vue"

export default {
  components: {
    AboutNav
  } 
}
</script>

<style lang="scss">
.about-page {
  .about-links {
    font-size: 1.15rem;
    li {
      margin-bottom: .5rem;
    }
  }
}
</style>